import { usePageDataStore } from "~/stores/user/pageData";

/**
 * Loads the logged-in person's ratings before the ratings page renders, on
 * the server for a full page load and on the client for a navigation.
 */
export default async function myRatingsMiddleware({ $pinia }) {
  await usePageDataStore($pinia).load("ratings");
}
